// Send event tracking data to Google Analytics
export function trackEvent (eventCategory, eventAction, eventLabel, eventValue = 1) {
  this.$ga.event({
    eventCategory,
    eventAction,
    eventLabel,
    eventValue
  })
}

// Send event tracking data to Google Analytics with callback. vue-analytics does not support callbacks on event tracking
export function trackEventWithCallback (eventCategory, eventAction, eventLabel, eventCallback) {
  // eslint-disable-next-line
  ga('send', 'event', eventCategory, eventAction, eventLabel, {
    hitCallback: () => {
      eventCallback()
    }
  })
}

export function trackGoogleAdConversion (import_properties) {
  var properties = {
    adwordsID: 'AW-943789358',
    conversionType: false,
    conversionID: false
  }

  // Merge default values with values passed into function
  Object.assign(properties, import_properties)

  switch (properties.conversionType) {
    case 'mobileclubsubmission':
      properties.conversionID = '6kx5CM-l5PABEK6qhMID'
      break
    case 'weeklyemailsubmission':
      properties.conversionID = 'tgGACIPf8fABEK6qhMID'
      break
    case 'appetiteemailsubmission':
      properties.conversionID = 'z_tnCJSv5PABEK6qhMID'
      break
    case 'ordersubmissionperkeyword':
      properties.conversionID = 'x6CYCJzHovYCEK6qhMID'
      break
    default:
  }

  if ('gtag' in window && properties.conversionType !== false) {
    window.gtag('event', 'conversion', {
      'send_to': properties.adwordsID + '/' + properties.conversionID,
      'event_callback': function () {
        if ('url' in properties) {
          window.location = properties.url
        }
      }
    })
  }

  return false
}
